export default [["á", "é", "í", "ó", "ú", "ü", "ñ", "¿", "?", "!"]]
